var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c(
                "b-card",
                [
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c("b-spinner", {
                            staticStyle: { width: "3rem", height: "3rem" },
                            attrs: { variant: "success", label: "Spinning" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { lg: "12" } },
                        [
                          _c(
                            "b-card",
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "12" } },
                                    [
                                      _c(
                                        "b-form",
                                        [
                                          _c(
                                            "b-form-group",
                                            [
                                              _c(
                                                "b-row",
                                                {
                                                  staticClass:
                                                    "align-items-center justify-content-end mb-1 w-100",
                                                },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { lg: "3" } },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "float-right",
                                                        },
                                                        [
                                                          _c(
                                                            "b-button",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "b-tooltip",
                                                                  rawName:
                                                                    "v-b-tooltip.hover.focus.v-dark",
                                                                  modifiers: {
                                                                    hover: true,
                                                                    focus: true,
                                                                    "v-dark": true,
                                                                  },
                                                                },
                                                              ],
                                                              attrs: {
                                                                variant:
                                                                  "secondary",
                                                                title:
                                                                  "Accepted file types: PDF, JPG, JPEG, PNG, GIF, TXT, CSV, DOC, DOCX, XLS, XLSX, PPT, PPTX, MP3, WAV, MP4, MOV, AVI, ZIP, RAR, 7Z, JS, CSS, HTML, XML.",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.openMediaDialog,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Browse & Upload"
                                                              ),
                                                            ]
                                                          ),
                                                          _c("input", {
                                                            ref: "mediaInput",
                                                            staticClass:
                                                              "d-none",
                                                            attrs: {
                                                              type: "file",
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.handleMediaUpload,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { lg: "12" } },
                                    [
                                      _c("b-table", {
                                        attrs: {
                                          items: _vm.formData.mediaURLs,
                                          fields: _vm.tableFields,
                                          hover: "",
                                          responsive: "",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "cell(mediaName)",
                                            fn: function (row) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(row.item.mediaName) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(download)",
                                            fn: function (row) {
                                              return [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "success",
                                                      size: "sm",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.getFileById(
                                                          row.item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Download")]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(actions)",
                                            fn: function (row) {
                                              return [
                                                _vm.HasPermission(
                                                  _vm.PermissionList
                                                    .Sales_Delete
                                                )
                                                  ? _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          variant: "danger",
                                                          size: "sm",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.confirmDelete(
                                                              row.item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("Delete")]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }